import React from 'react';
import { useSelector } from 'react-redux';
import { billingSelectorToQueryString } from '@debbie/cortex/dist/api/billing';
import { selectTenantId } from '@debbie/cortex/dist/selectedOwners/selectors';
import { File } from '..';
import { APIBASE } from '../../config';
import { getBillingIdentity } from '../Billing';
const ExcelPreview = (props) => {
    const lang = useSelector((s) => s.lang);
    const tenantId = useSelector(selectTenantId);
    const currentLang = useSelector((s) => s.currentLang);
    const identity = getBillingIdentity(props.billing, lang);
    const EXCELURL = `${APIBASE}/v1/${tenantId}/billings/${props.billingSelector ? 'ongoing-work-billing' : props.billing.billingId}/excel?lang=${currentLang}&${props.billingSelector
        ? billingSelectorToQueryString(props.billingSelector)
        : ''}`;
    return (React.createElement("div", null,
        React.createElement(File, { style: { margin: '0' }, download: true, file: {
                fileName: `${identity}.xlsx`,
                contentType: 'application/vnd.ms-excel',
                url: EXCELURL,
            } })));
};
export default ExcelPreview;
//# sourceMappingURL=ExcelPreview.js.map